var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12525 5H11.148V7H9.12525V5ZM9.12525 9H11.148V15H9.12525V9ZM10.1366 0C4.55387 0 0.0229492 4.48 0.0229492 10C0.0229492 15.52 4.55387 20 10.1366 20C15.7194 20 20.2503 15.52 20.2503 10C20.2503 4.48 15.7194 0 10.1366 0ZM10.1366 18C5.67649 18 2.04568 14.41 2.04568 10C2.04568 5.59 5.67649 2 10.1366 2C14.5967 2 18.2276 5.59 18.2276 10C18.2276 14.41 14.5967 18 10.1366 18Z",
    fill: "#A0CDFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCardIcon);
export default __webpack_public_path__ + "static/media/DefaultCardIcon.4e18a465.svg";
export { ForwardRef as ReactComponent };